type TabObject = {
  tab: "/aboutModel" | "/problemType" | '/modelPurpose' |'/trainingModelOnSingleEpoch'| '/convertingDataFromModelFormatToTestingAnalytics'| "/modelDetailsTab" | '/dataFormat' | '/hyperParameters'| "/convertingFromRlefToModel" | '/modelDetails' | '/runtimeCode' | '/deployment' | '/dataMapping' | '/metadata' | '/codetestinghardware';
}

export const SCENARIO_TEXT = "scenario";
export const tabsCreatorHasSeen: TabObject[] = [
  { tab: "/aboutModel" },
  { tab: "/problemType" },
  { tab: "/modelDetailsTab" },
  { tab: "/codetestinghardware" }
];

export interface tabsCreatorHasSeenPayload {
  purposeModelId: string;
  tabDetail: TabObject;
}

export const RedAsterisk: React.FC = () => {
  return <span style={{ color: 'red' }}>*</span>;
};